'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorInsertComment = function EditorInsertComment(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z' })
  );
};
EditorInsertComment = (0, _pure2.default)(EditorInsertComment);
EditorInsertComment.displayName = 'EditorInsertComment';
EditorInsertComment.muiName = 'SvgIcon';

exports.default = EditorInsertComment;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/editor/insert-comment.js
 ** module id = 1932
 ** module chunks = 0
 **/